import { AccountType } from '@xbcb/shared-types';
import { WorkOrderTaskType } from '@xbcb/work-order-types';
import { setModal } from 'actions';
import { ModalKey } from 'types';
import { AppRecordKebabMenuItem } from '../../types';
import { isContinuousBondAutomationEnabled } from 'featureFlags';

export const usIorContinuousBondRequestChargeBondRenewalKebabMenuItem: AppRecordKebabMenuItem =
  {
    key: 'chargeBondRenewal',
    text: 'Charge Bond Renewal',
    show: ({ currentUser, workOrderTaskType }) =>
      currentUser.accountType === AccountType.OPERATOR &&
      isContinuousBondAutomationEnabled &&
      workOrderTaskType ===
        WorkOrderTaskType.US_IOR_CONTINUOUS_BOND_CHARGE_BOND_RENEWAL_EXCEPTION,
    action: ({ dispatch, record }) => {
      dispatch(
        setModal({
          key: ModalKey.CHARGE_CONTINUOUS_BOND_RENEWAL,
          props: {
            usIorContinuousBondRequest: record,
            visible: true,
          },
        }),
      );
    },
  };
